import { GenIcon } from '../helpers/IconBase.es.js';

const DiscountFilled = (props) => {
    return GenIcon({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M3 12C3 7.03725 7.03725 3 12 3C16.9627 3 21 7.03725 21 12C21 16.9627 16.9627 21 12 21C7.03725 21 3 16.9627 3 12ZM9 7.5C8.17125 7.5 7.5 8.17125 7.5 9C7.5 9.82875 8.17125 10.5 9 10.5C9.82875 10.5 10.5 9.82875 10.5 9C10.5 8.17125 9.82875 7.5 9 7.5ZM13.5001 15C13.5001 15.8287 14.1713 16.5 15.0001 16.5C15.8288 16.5 16.5001 15.8287 16.5001 15C16.5001 14.1712 15.8288 13.5 15.0001 13.5C14.1713 13.5 13.5001 14.1712 13.5001 15ZM9.5302 15.5302C9.23736 15.8231 8.76255 15.8231 8.4697 15.5302C8.17685 15.2374 8.17685 14.7626 8.4697 14.4697L14.4697 8.4697C14.7626 8.17685 15.2374 8.17685 15.5302 8.4697C15.8231 8.76255 15.8231 9.23735 15.5302 9.5302L9.5302 15.5302Z',
                    fill: '#82869E',
                },
            },
        ],
    })(props);
};

export { DiscountFilled };
